// extracted by mini-css-extract-plugin
module.exports = {"canvas":"Background_canvas__1yauc"};